import { useUser } from '@innovamat/ga-features';
import { Navigate } from 'react-router-dom';

function ProtectedAdminRoute({
  children,
}: {
  children: React.ReactNode;
}): React.ReactNode {
  const { isRole, user } = useUser();

  if (!user) {
    return children;
  }

  if (isRole.Admin || isRole.Advisor || isRole.DistrictAdmin || isRole.Owner) {
    return children;
  }

  return <Navigate to="/" />;
}

export { ProtectedAdminRoute };
